module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/starFull@3x-93dd385ecfadb66f282081c3fe4e7b4f.png";